﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { GcRsData } from '../models/gc-rs-data';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Summary,
    TotalItem,
    Toolbar,
    Item as ToolBarItem
} from 'devextreme-react/data-grid';
import { CrudFunctions } from '../utilities/crud-functions';

export interface Props {
    benchSheetId?: string;
}

export default function GcRsReportedSolvents(props: Props) {
    const [solventData, setSolventData] =
        useState<GcRsData>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div>
            <div className="lq-sub-title pw-blue">Blanks</div>
            <div>
                <DataGrid
                    height="7rem"
                    wordWrapEnabled={true}
                    keyExpr="solventId"
                    dataSource={solventData && solventData.blankSamples ?
                        solventData.blankSamples : []}
                    showBorders={true} >

                    <Selection mode='single' />

                    <Column dataField='sampleName' width='20%' />
                    <Column dataField='solventImpurity' width='20%' />
                    <Column dataField='retentionTime' caption="Retention Time (min)"
                        dataType="number" width={'20%'} />
                    <Column dataField='finalConcentration' caption="Final Concentration (%)"
                        dataType="number" width='20%' />

                    <Paging enabled={false} />
                </DataGrid>
            </div>
            <br />
            <div className="lq-sub-title pw-blue">QC Samples</div>
            <div>
                <DataGrid
                    height="7rem"
                    wordWrapEnabled={true}
                    keyExpr="solventId"
                    dataSource={solventData && solventData.qcSamples ?
                        solventData.qcSamples : []}
                    showBorders={true} >

                    <Selection mode='single' />

                    <Column dataField='sampleName' width='20%' />
                    <Column dataField='solventImpurity' width='20%' />
                    <Column dataField='retentionTime' caption="Retention Time (min)"
                        dataType="number" width='20%' />
                    <Column dataField='finalConcentration' caption="Final Concentration (%)"
                        dataType="number" width='20%' />

                    <Paging enabled={false} />
                </DataGrid>
            </div>

            <br />
            <div>
                <DataGrid
                    height="13rem"
                    wordWrapEnabled={true}
                    keyExpr="solventId"
                    dataSource={solventData && solventData.solvents ?
                        solventData.solvents : []}
                    showBorders={true} >

                    <Selection mode='single' />

                    <Column dataField='sampleName' width='20%' />
                    <Column dataField='solventImpurity' width='20%' />
                    <Column dataField='retentionTime' caption="Retention Time (min)"
                        dataType="number" width='20%' />
                    <Column dataField='finalConcentration' caption="Final Concentration (%)"
                        dataType="number" width='20%' />

                    <Summary>
                        <TotalItem
                            column="finalConcentration"
                            displayFormat="Total Solvent Impurities: {0}"
                            valueFormat={{ type: "fixedPoint", precision: 3 }}
                            summaryType="sum" />
                    </Summary>

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Samples</div>
                            </div>
                        </ToolBarItem>
                    </Toolbar>

                </DataGrid>
            </div>
        </div>
    );
        
    async function getAllData() {


        //todo get RS data

    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
 
    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
